import LessonActivitySelectMultiple from "./LessonActivitySelectMultiple";

export default LessonActivitySelectMultiple;
